import React,{Component} from "react";
import { connect } from "react-redux";
import { Modal, ModalHeader,ModalBody, Col, Row } from 'reactstrap';
import SubLocationAdd from "./Add";
import Actions from "../../../../Actions";
import Tile from "../../Layout/Tile";
import Confirm from "../../Layout/Confirm";
import AddButton from "../../Layout/AddButton";

class SubLocationsModal extends Component{
    constructor(props){
        super(props);
        this.modalRef = false;
    }

    render = () => {
        const { toggleModal, modalStore: { display: { modal, data: { id: location_id = false } } }, token, deleteSubLocation, locations } = this.props;
        const sub_locations = !location_id ? []: locations[location_id].sub_locations;
        
        return (
            <div>
                <Modal size="lg" isOpen={modal} toggle={() => toggleModal("subLocations","display")}>
                    <ModalHeader toggle={() => toggleModal("subLocations","display")}> Sub Locations </ModalHeader>
                    <ModalBody style={{backgroundColor:"#f2f2f2"}}>
                        <AddButton type="subLocations" data={{location_id}} />
                        <div ref={(ref) => this.modalRef = ref}>    
                            {sub_locations.map((subLocation, uid) => {
                                const { location_id, id } = subLocation;
                                return(
                                    <Tile xs="11" key={uid} style={{marginTop:5, padding: 0}}>
                                        <Row>
                                            <Col xs="6">
                                                <p style={{padding:15}}>{subLocation.name}</p>
                                            </Col>
                                            <Col xs={{size: 2, offset: 4}}>
                                                <div style={{padding:15}}><Confirm confirm={() => deleteSubLocation(token, location_id, id, this.toggle)} /></div>
                                            </Col>
                                        </Row>
                                    </Tile>
                                );
                            })}
                        </div>
                    </ModalBody>
                </Modal>
                <SubLocationAdd/>
            </div>                            
        );
    }
}

const mapStateToProps = (state) => ({
    permissions: state.auth.permissions,
    token: state.auth.token,
    modalStore: state.modalStore.subLocations,
    locations: state.locationStore.locations,
});

const { locations, modals } = Actions;

export default connect(mapStateToProps, { ...locations, ...modals })(SubLocationsModal);


// WEBPACK FOOTER //
// ./src/Components/App/Locations/SubLocations/Modal.js